import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useReducedMotion } from '../hooks/useReducedMotion';
import '../styles/scene-motion.css';
export default function SceneRouteMotion({children}:{children:React.ReactNode}) {
 const {pathname}=useLocation(); const reduced=useReducedMotion(); const ref=useRef<HTMLDivElement>(null);
 useEffect(()=>{const node=ref.current; if (!node || reduced || !node.animate) return; const animation=node.animate([{opacity:.75,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'}); return ()=>animation.cancel();},[pathname,reduced]);
 return <div ref={ref} className={reduced ? 'scene-motion reduced-motion' : 'scene-motion'}>{children}</div>;
}
